import React from "react";
import styled from "styled-components";
import { useExternalMedia } from "../../../../hooks/useExternalMedia";



const AboutEratekImageWrapper = () => {


  const { aboutEratekImage } = useExternalMedia();

  return (
    <BackgroundImageWrapper
      style={{
        backgroundImage: `url(${aboutEratekImage})`,
      }}
    ></BackgroundImageWrapper>
  );
};

export default AboutEratekImageWrapper;

const BackgroundImageWrapper = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  border-radius: 10px;
  min-height: 100%;
`;
